"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusDialogMixin = void 0;
var _drywall = require("drywall");
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Anchor = require("../components/Anchor/Anchor.styles");
var _Icon = require("../components/Icon/Icon.styles");
var _Text = require("../components/Text/Text.styles");
var _TextButton = require("../components/TextButton/TextButton.styles");
var _hoverMediaQueryMixin = require("./hoverMediaQueryMixin");
var _spaceMixin = require("./spaceMixin");
var _typographyMixin = require("./typographyMixin");
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  return (0, _styledToken.default)({
    background: "status." + appearance + ".background",
    borderColor: "status." + appearance + ".border",
    color: "status." + appearance + ".foreground"
  }, function (_ref) {
    var background = _ref.background,
      borderColor = _ref.borderColor,
      color = _ref.color;
    return (0, _styledComponents.css)(["background:", ";border:1px solid ", ";", "{color:", ";}"], background, borderColor, _drywall.Toast.Icon, color);
  })(props);
};
var inverseAppearanceCSS = function inverseAppearanceCSS(props) {
  var appearance = props.appearance;
  return (0, _styledToken.default)({
    background: "status." + appearance + ".darkBackground",
    color: 'colors.white',
    closeButtonBackgroundInverse: 'CloseButton.backgroundColorInverse'
  }, function (_ref2) {
    var background = _ref2.background,
      color = _ref2.color,
      closeButtonBackgroundInverse = _ref2.closeButtonBackgroundInverse;
    return (0, _styledComponents.css)(["background:", ";border:0;&,", ",", ",", ",", "{color:", ";}", "{&,&:visited,&:active{color:", ";}", ";}", "{text-decoration:underline;}", "{&:hover,&:focus{background-color:", ";}}"], background, _drywall.CloseButton, _Text.StyledText, _TextButton.StyledTextButton, _drywall.Toast.Icon, color, _Anchor.StyledAnchor, color, (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("color: " + color + ";"), _TextButton.StyledTextButton, _drywall.CloseButton, closeButtonBackgroundInverse);
  })(props);
};

/** @mixin statusDialogMixin */
/**
 * @method
 */
var statusDialogMixin = function statusDialogMixin(props) {
  var inverse = props.inverse;
  return (0, _styledToken.default)({
    fontType: 'status.fontType',
    iconSize: 'status.iconSize'
  }, function (_ref3) {
    var fontType = _ref3.fontType,
      iconSize = _ref3.iconSize;
    return (0, _styledComponents.css)(["box-sizing:border-box;padding:", ";", " ", " display:flex;", ",", ",", ",", "{flex:0 0 auto;}", ",", "{margin-left:", ";}", "{margin-right:", ";height:", "px;width:", "px;", "{height:100%;width:100%;}}", "{display:flex;}"], (0, _spaceMixin.spaceMixin)('sm')(props), inverse ? inverseAppearanceCSS(props) : appearanceCSS(props), (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), _drywall.Toast.Body, _drywall.Toast.Action, _drywall.Toast.Close, _drywall.Toast.Icon, _drywall.Toast.Action, _drywall.Toast.Close, (0, _spaceMixin.spaceMixin)('sm')(props), _drywall.Toast.Icon, (0, _spaceMixin.spaceMixin)('sm')(props), iconSize, iconSize, _Icon.StyledIcon, _drywall.Toast.Close);
  })(props);
};
exports.statusDialogMixin = statusDialogMixin;